export default function responsiveFont(fontSize, mdMatches) {
  const px = fontSize * (4 / 3);
  if (mdMatches) return `${(px / 1920) * 100}vw`;
  else return `${(px / 900) * 100}vw`;
}
